/**
 * Interval Catalog for charts
 */
const IntervalCatalog = {
  custom: 'Custom',
  month: 'Month',
};

export default IntervalCatalog;
